'use es6';

import { createAction } from 'flux-actions';
import * as ActionTypes from '../constants/VisitorActionTypes';
export const onInputFocusAction = createAction(ActionTypes.USER_INPUT_ON_FOCUS, inputFocus => ({
  widgetInputIsOnFocus: inputFocus
}));
export function toggleOnAndOffInputFocus(inputFocus) {
  return dispatch => {
    dispatch(onInputFocusAction(inputFocus));
  };
}